import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Resolve a backend-uploaded media path (audio, video, image) to a URL the
 * browser can load. We prefer a SAME-ORIGIN path whenever possible so the
 * browser doesn't need to deal with cross-origin metadata fetches, which can
 * cause HTML5 <audio>/<video> elements to silently show 0:00 duration.
 *
 * - In preview (frontend on `*.preview.emergentagent.com`) → returns a path
 *   that points at the preview backend (same origin, no CORS).
 * - In production (frontend on `hologram-club.com`) → returns a same-origin
 *   path. The deployment proxies /api/* to the backend so this Just Works.
 * - For absolute URLs (https://...) → returned as-is.
 */
export function mediaUrl(rawPath) {
  if (!rawPath) return null;
  if (/^https?:\/\//i.test(rawPath)) return rawPath;
  if (rawPath.startsWith("/api")) {
    if (typeof window !== "undefined" && window.location && window.location.origin) {
      return `${window.location.origin}${rawPath}`;
    }
    return `${BACKEND_URL}${rawPath}`;
  }
  return rawPath;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
